import React from 'react';
import './PlansSection.css';
import { useTranslation } from 'react-i18next';

const PlansSection = () => {
  const { t } = useTranslation();
  const features = [
    ['search', '⌕', true], ['verified', '✓'], ['offers', '◈'],
    ['chat', '◌'], ['career', '↗'], ['reputation', '✦']
  ];

  return (
    <section className="wb-opportunity-section" id="fourth-div">
      <div className="wb-opportunity-scan" aria-hidden="true" />
      <div className="wb-opportunity-shell">
        <header className="wb-opportunity-header">
          <div><span className="wb-opportunity-eyebrow">{t('websiteUi.opportunityEngine')} <i /></span><h2>{t('featuress.title')}</h2></div>
          <p>{t('website.opportunityLead')}</p>
        </header>
        <div className="wb-opportunity-mosaic">
          {features.map(([key, icon, main], index) => (
            <article className={`wb-opportunity-card ${main ? 'wb-opportunity-main' : ''}`} key={key}>
              <div className="wb-opportunity-top"><span>{t('websiteUi.module')} {String(index + 1).padStart(2, '0')}</span><b>{main ? t('websiteUi.core') : t('websiteUi.live')}</b></div>
              <div className="wb-opportunity-icon">{icon}</div>
              <h3>{t(`featuress.${key}Title`)}</h3>
              <p>{t(`featuress.${key}Text`)}</p>
              <div className="wb-opportunity-footer"><span>{t('websiteUi.activated')}</span><i /></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlansSection;
